import type { ApiEndpoints } from '@avisoma/shared';
import { DocumentModelUsageSummary } from '../../components/DocumentModelUsageSummary';
import { PageProcessingSummary } from '../../components/PageProcessingSummary';
import { OpenItems } from './OpenItems';

interface ProjectOverviewSummariesProps {
  response: ApiEndpoints<string>['/api/projects/:id']['GET']['response'];
}

export function ProjectOverviewSummaries({ response }: ProjectOverviewSummariesProps) {
  return (
    <div className="flex flex-col gap-8">
      <DocumentModelUsageSummary
        segmentationUsage={response.item.modelUsage.segmentation}
        pdfParserUsage={response.item.modelUsage.pdfParser}
        dataExtractionUsage={response.item.modelUsage.dataExtraction}
        dataExtractionFlashPreviewUsage={response.item.modelUsage.dataExtractionFlashPreview}
        embeddingsUsage={response.item.modelUsage.embeddings}
        htmlConversionCostUsd={response.item.modelUsage.htmlConversionCostUsd}
        pageCount={response.item.modelUsage.totalPageCount}
        title="Model API usage (project)"
        collapsibleStorageKey="projectView.collapsible.modelApiUsage"
      />
      <PageProcessingSummary
        processing={response.item.pageProcessing}
        errorHref={`/document-pages?projectId=${encodeURIComponent(response.item.id)}&status=error`}
        dataExtractionErrorHref={`/documents?projectId=${encodeURIComponent(response.item.id)}&status=error`}
        supervisorRun={response.item.supervisorRun}
        supervisorHref={`/projects/${response.item.id}?tab=corrections`}
      />
      <OpenItems key={response.item.id} projectId={response.item.id} />
    </div>
  );
}
